export default "__VITE_ASSET__L82717cO__"